<template>
    <div class="soli-round" :class="{ white: !dark }">
        <div
            class="mb-3 soli-grey text-align-start font-weight-bold text-h3"
            :class="{ 'white--text': dark }"
        >
            <slot></slot>
        </div>
        <div
            class="px-1 soli-grey text-align-start text-lg"
            :class="{ 'white--text': dark }"
        >
            <slot name="subtitle"></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        dark: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
